import { graphql } from '../../graphql/generated';

export const ORDER_REPORT_QUERY = graphql(`
  query OrderReport($doctorId: ID!) {
    doctor(id: $doctorId) {
      id
      assignedLabs {
        lab {
          id
          shortName
          name
          identifier
        }
      }
    }

    labs {
      id
    }

    openRequests(doctorId: $doctorId, svnr: null) {
      orders {
        id
        number
        createdAt
        lab {
          id
        }
        request {
          id
          comment
          patientData {
            svnr
            title
            firstName
            lastName
            birthday
          }
        }
      }
    }
  }
`);
